//This file just contains constants that can be re-used to identify the type of action

export const EQUIPMENT_ADDED_TO_ADDED_EQUIPMENT_LIST = "EQUIPMENT_ADDED_TO_ADDED_EQUIPMENT_LIST";
export const REMOVE_EQUIPMENT_FROM_ADDED_EQUIPMENT_LIST = "REMOVE_EQUIPMENT_FROM_ADDED_EQUIPMENT_LIST";
